<template>
  <div class="chat-composer">
    <div class="chat-composer__chips" v-if="showSuggestions">
      <button
        type="button"
        class="chat-composer__chip"
        v-for="chip in suggestions"
        :key="chip.label"
        @click="send(chip.text)"
      >{{ chip.label }}</button>
    </div>
    <form class="chat-composer__form" @submit.prevent="submit">
      <textarea
        ref="input"
        v-model="draft"
        class="chat-composer__input"
        rows="1"
        :placeholder="placeholder"
        :disabled="isLoading"
        @keydown.enter.exact.prevent="submit"
        @input="autoGrow"
      ></textarea>
      <button
        type="submit"
        class="chat-composer__send"
        :disabled="isLoading || !draft.trim()"
        aria-label="Enviar mensaje"
      >
        <span class="fa fa-paper-plane"></span>
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'ChatComposer',
  props: {
    placeholder: {
      type: String,
      default: 'Cuéntame qué buscas: “piso de 2 habitaciones en Villena”…'
    },
    autofocus: { type: Boolean, default: false },
    // En la home, al enviar se abre el panel lateral y la conversación continúa allí.
    openDockOnSend: { type: Boolean, default: false },
    // La home muestra sus propios botones grandes; ocultamos los chips del composer.
    hideChips: { type: Boolean, default: false }
  },
  data () {
    return {
      draft: '',
      suggestions: [
        { label: '🏠 Buscar vivienda', text: 'Quiero buscar una vivienda' },
        { label: '🏢 Local o nave', text: 'Busco un local o una nave' },
        { label: '💼 Vender el mío', text: 'Quiero vender mi inmueble' },
        { label: '🔑 Alquilar el mío', text: 'Quiero alquilar mi inmueble' },
        { label: '📅 Solicitar visita', text: 'Quiero agendar una visita con un asesor' },
        { label: '🧑‍💼 Hablar con un asesor', text: 'Quiero que un asesor se ponga en contacto conmigo' }
      ]
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.chat.isLoading
    },
    showSuggestions () {
      return !this.hideChips && !this.$store.getters['chat/hasConversation']
    }
  },
  mounted () {
    if (this.autofocus) this.focus()
  },
  methods: {
    focus () {
      if (this.$refs.input) this.$refs.input.focus()
    },
    autoGrow () {
      const el = this.$refs.input
      if (!el) return
      el.style.height = 'auto'
      el.style.height = `${Math.min(el.scrollHeight, 120)}px`
    },
    submit () {
      this.send(this.draft)
    },
    send (text) {
      if (this.isLoading || !text.trim()) return
      this.draft = ''
      this.$nextTick(this.autoGrow)
      if (this.openDockOnSend) this.$store.dispatch('chat/openPanel')
      this.$store.dispatch('chat/send', text)
      this.$emit('sent')
    }
  }
}
</script>

<style scoped>
.chat-composer__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}
.chat-composer__chip {
  background: #fff;
  border: 1px solid #E0E3E6;
  border-radius: 999px;
  padding: 7px 14px;
  font-size: 13px;
  color: #1D262D;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}
.chat-composer__chip:hover {
  border-color: #E45726;
  background: #FDEDE7;
}
.chat-composer__form {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  background: #fff;
  border: 1px solid #E0E3E6;
  border-radius: 24px;
  padding: 6px 6px 6px 16px;
  box-shadow: 0 2px 12px rgba(29, 38, 45, 0.08);
}
.chat-composer__input {
  flex: 1;
  border: none;
  outline: none;
  resize: none;
  font-size: 15px;
  line-height: 1.4;
  padding: 8px 0;
  max-height: 120px;
  background: transparent;
  color: #1D262D;
}
.chat-composer__send {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: #E45726;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
}
.chat-composer__send:hover:not(:disabled) { background: #cc3e13; }
.chat-composer__send:disabled { background: #C9CDD1; cursor: default; }
</style>
